import { EarningMechanismTypename, EarningMechanismWithProgressTypename } from './earning-mechanism.types';
import { EarningMechanismWithProgressTypenames } from './earning-mechanism.constants';

export const isEarningMechanismTypenameIsWithProgress = (
  typename: EarningMechanismTypename,
): typename is EarningMechanismWithProgressTypename => {
  return EarningMechanismWithProgressTypenames.includes(typename);
};
